"use client";

import Link from "next/link";

import cn from "classnames";

import { resolveLinkHref } from "@/utils/url.util";

import { brown } from "@/app/font";

import type { BuildProtectionLink } from "./buildProtection.types";

export function BuildProtectionCta({
  link,
  label,
  className,
  testId,
  ariaLabel,
  variant,
  onClick,
}: BuildProtectionCtaProps) {
  const href = resolveLinkHref(link);
  if (!label || !href || href === "#") return null;

  return (
    <Link
      href={href}
      data-testid={testId}
      aria-label={ariaLabel}
      onClick={onClick}
      target={link?.openInNewTab ? "_blank" : undefined}
      rel={link?.openInNewTab ? "noopener noreferrer" : undefined}
      style={variant === "amber" ? { backgroundColor: "#FFB400" } : undefined}
      className={cn(
        "focus-visible:ring-secondary inline-flex items-center justify-center focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none motion-reduce:transition-none",
        variant === "text"
          ? "text-greyscale-headline w-fit border-b border-current text-sm font-semibold"
          : cn(
              brown.className,
              "min-h-12 rounded-full px-8 py-3 text-center text-sm font-bold uppercase",
              variant === "amber" && "bg-adt-amber text-secondary",
              variant === "navy" && "bg-secondary text-white",
              variant === "outline" &&
                "border-secondary text-secondary border-2 bg-white",
            ),
        className,
      )}>
      {label}
    </Link>
  );
}

type BuildProtectionCtaProps = {
  link?: BuildProtectionLink | null;
  label?: string | null;
  className?: string;
  testId?: string;
  ariaLabel?: string;
  variant: "amber" | "navy" | "outline" | "text";
  onClick?: () => void;
};
